import {
    useCallback,
    useEffect,
    useRef,
    useState,
} from 'react';

import {
    getInnerWidth,
} from '../helpers/getInnerWidth';

export function useWindowWidth() {
    const [windowWidth, setWindowWidth] = useState(typeof window === 'undefined' ? 0 : getInnerWidth);

    const isMounted = useRef(true);

    const handleResize = useCallback(() => {
        if (!isMounted.current) {
            return;
        }

        setWindowWidth(getInnerWidth);
    }, [setWindowWidth]);

    useEffect(() => {
        window.addEventListener('resize', () => {
            window.requestAnimationFrame(handleResize);
        });

        return () => {
            isMounted.current = false;
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    return {
        windowWidth,
    };
}
